import {
  listarConversaciones,
  getMensajes,
  enviarMensaje,
  marcarLeidas,
  marcarObservada,
  rechazarPropuesta,
  listarInv,
  getInvMensajes,
  enviarInv,
  marcarLeidasInv,
} from './chatApi';

class ChatApi {
  listarConversaciones() {
    return listarConversaciones();
  }
  getMensajes(operacionId) {
    return getMensajes(operacionId);
  }
  enviarMensaje(operacionId, mensaje) {
    return enviarMensaje(operacionId, mensaje);
  }
  marcarLeidas(operacionId) {
    return marcarLeidas(operacionId);
  }
  marcarObservada(operacionId, mensaje) {
    return marcarObservada(operacionId, mensaje);
  }
  rechazarPropuesta(operacionId, mensaje) {
    return rechazarPropuesta(operacionId, mensaje);
  }
  listarInv() {
    return listarInv();
  }
  getInvMensajes(operacionId, inversionistaId) {
    return getInvMensajes(operacionId, inversionistaId);
  }
  enviarInv(operacionId, inversionistaId, mensaje) {
    return enviarInv(operacionId, inversionistaId, mensaje);
  }
  marcarLeidasInv(operacionId, inversionistaId) {
    return marcarLeidasInv(operacionId, inversionistaId);
  }
}

export const chatApi = new ChatApi();
